import React, {Component, Fragment} from 'react';
// import {MultiSelect} from 'react-selectize';
import {Label} from 'reactstrap';
import Select from 'react-select';

class PropNumSelector extends Component {
	constructor(props) {
		super(props);
		this.onValueChange = this.onValueChange.bind(this);
	}

	onValueChange(selectedOptions) {
		let nextValues = selectedOptions.map((opt) => {
			return opt.value;
		});
		return this.props.handlePropertyUpdate(nextValues);
	}

	render() {
		let colorStyles = {
			option: (styles) => {
				return {
					...styles
				};
			}
		};

		if (this.props.themeName === 'DARK') {
			colorStyles = {
				control: (styles) => {
					let result = Object.assign(styles, {backgroundColor: '#232323'});
					return result;
				},

				input: (styles) => {
					let result = Object.assign(styles, {color: 'white'});
					return result;
				},

				menu: (styles) => {
					let result = Object.assign(styles, {backgroundColor: '#272727'});
					return result;
				},

				multiValue: (styles) => {
					let result = Object.assign(styles, {backgroundColor: '#696969'});
					return result;
				},

				multiValueLabel: (styles) => {
					let result = Object.assign(styles, {color: 'white'});
					return result;
				},

				option: (styles, {isFocused}) => {
					let backgroundColor = '#272727';
					if (isFocused) {
						backgroundColor = '#696969';
					}

					let result = Object.assign(styles, {backgroundColor: backgroundColor});
					return result;
				}
			};
		}

		// TODO: I leave red mode to you, Craig. You can see how I styled the PropNumSelector for dark mode above.
		// Feel free to rework any of my styles.

		return (
			<Fragment>
				<Label
					className="simpleLabel"
					for='property-select'
				>
					Properties{' '}
				</Label>
				<Select
					id="property-select"
					className="basic-multi-select textinput"
					classNamePrefix="select"
					isMulti
					onChange={this.onValueChange}
					options={this.props.options}
					styles={colorStyles}
					value={this.props.value}
				/>
			</Fragment>
		);

	}

}

export default PropNumSelector;

// defaultValue={this.state.selectedOptions}



// WEBPACK FOOTER //
// ./src/components/PropNumSelector.js